(function() {
  var redirects = {

    // TOOL HOLDERS //
    "/aB24Li": "https://www.pactoolsusa.com/",
    "/jM84Vt": "https://www.pactoolsusa.com/collections/er-collet-holders",
    "/kM43Yc": "https://www.pactoolsusa.com/collections/er-collet-holders",
    "/rC61Yp": "https://www.pactoolsusa.com/collections/er-collet-holders",
    "/cH67Cy": "https://www.pactoolsusa.com/collections/end-mill-holders",
    "/qD24Oq": "https://www.pactoolsusa.com/collections/end-mill-holders",
    "/lX84Ug": "https://www.pactoolsusa.com/collections/end-mill-holders",
    "/bR47Wu": "https://www.pactoolsusa.com/collections/shrink-fit-holders",
    "/hA88Tn": "https://www.pactoolsusa.com/collections/shrink-fit-holders",
    "/uC14Sp": "https://www.pactoolsusa.com/collections/face-mill-holders",
    "/iD47Wn": "https://www.pactoolsusa.com/collections/face-mill-holders",
    "/vU12Lc": "https://www.pactoolsusa.com/collections/face-mill-holders",
    "/rH96Lb": "https://www.pactoolsusa.com/collections/hydraulic-holders",
    "/zR31Oe": "https://www.pactoolsusa.com/collections/power-milling-holders",
    "/aC50Hw": "https://www.pactoolsusa.com/collections/power-milling-holders",
    "/nP58Xm": "https://www.pactoolsusa.com/collections/quick-change-tapping-holders",
    "/kJ64Ed": "https://www.pactoolsusa.com/",
    "/nG53Zl": "https://www.pactoolsusa.com/",
    "/bX93Fw": "https://www.pactoolsusa.com/collections/er-straight-shank-holders",
    "/vT12Sv": "https://www.pactoolsusa.com/collections/er-straight-shank-holders",
    // TOOL HOLDERS END //


    // COLLETS //
    "/eI00Vs": "https://www.pactoolsusa.com/collections/er-collets",
    "/cQ53Cc": "https://www.pactoolsusa.com/collections/er-collets?filter.p.m.custom.iscolletset=1",
    "/vH14Vu": "https://www.pactoolsusa.com/collections/er-steel-sealed-collets",
    "/oP25Na": "https://www.pactoolsusa.com/collections/er-steel-sealed-collets?filter.p.m.custom.iscolletset=1",
    "/lB46Tf": "https://www.pactoolsusa.com/collections/er-jet-spray-coolant-collets",
    "/yV43Nh": "https://www.pactoolsusa.com/",
    "/cR82Uw": "https://www.pactoolsusa.com/collections/er-tap-collets",
    "/dP74Pk": "https://www.pactoolsusa.com/collections/er-tap-collets?filter.p.m.custom.iscolletset=1",
    "/rT94Fg": "https://www.pactoolsusa.com/collections/er-tap-steel-sealed-collets",
    "/aF17Qf": "https://www.pactoolsusa.com/collections/er-tap-steel-sealed-collets?filter.p.m.custom.iscolletset=1",
    "/bT36Jn": "https://www.pactoolsusa.com/collections/er-floating-tap-collets",
    "/tT78Wb": "https://www.pactoolsusa.com/collections/quick-change-tapping-adapters-collets",
    "/wH18Lp": "https://www.pactoolsusa.com/collections/dna-dead-nut-accurate-collets",
    "/uM64Fz": "https://www.pactoolsusa.com/collections/sk-collets-super-collets",
    "/zC24Pk": "https://www.pactoolsusa.com/collections/sk-collets-super-collets?filter.p.m.custom.iscolletset=1",
    "/iJ59Qu": "https://www.pactoolsusa.com/collections/da-collets",
    "/yV48Sl": "https://www.pactoolsusa.com/collections/da-sealed-collets",
    "/tM49Ti": "https://www.pactoolsusa.com/collections/da-collets?filter.p.m.custom.iscolletset=1",
    "/pI10Pi": "https://www.pactoolsusa.com/collections/tg-collets",
    "/hY63Bu": "https://www.pactoolsusa.com/collections/tg-sealed-collets",
    "/cX13Th": "https://www.pactoolsusa.com/collections/tg-tap-collets",
    "/jQ51Jd": "https://www.pactoolsusa.com/collections/tg-collets?filter.p.m.custom.iscolletset=1",
    "/vO25Gv": "https://www.pactoolsusa.com/",
    "/qB27Pv": "https://www.pactoolsusa.com/collections/oz-eoc-collets",
    "/tP72Ts": "https://www.pactoolsusa.com/",
    "/mW49Xz": "https://www.pactoolsusa.com/collections/straight-collets-for-milling-chucks",
    "/fX56Qe": "https://www.pactoolsusa.com/",
    "/vS27Zk": "https://www.pactoolsusa.com/",
    "/tX14Ub": "https://www.pactoolsusa.com/collections/quick-change-tapping-adapters-collets",
    "/iN15Rz": "https://www.pactoolsusa.com/",
    "/dR27Be": "https://www.pactoolsusa.com/collections/er-steel-sealed-collets-metalic-sealed",
    "/zP22Uq": "https://www.pactoolsusa.com/collections/5c-collets",
    "/uE90Cx": "https://www.pactoolsusa.com/collections/3j-collets",
    "/jL59Bp": "https://www.pactoolsusa.com/collections/16c-collets",
    "/cZ61Rw": "https://www.pactoolsusa.com/",
    // COLLETS END //


    // TOOL HOLDER BUSHINGS/TURRET SLEEVES //
    "/eE25Kq": "https://www.pactoolsusa.com/collections/type-c-bushings",
    "/hO14Tr": "https://www.pactoolsusa.com/collections/type-cs-bushings",
    "/yD11Ky": "https://www.pactoolsusa.com/collections/type-z-bushings",
    "/mW96Mk": "https://www.pactoolsusa.com/collections/type-j-bushings",
    "/gG53Lz": "https://www.pactoolsusa.com/collections/type-b-bushings",
    "/eY98Ap": "https://www.pactoolsusa.com/collections/boring-bar-sleeves",
    // TOOL HOLDER BUSHINGS/TURRET SLEEVES END //

    // RETENTION KNOBS-PULL STUDS //
    "/fZ40Rb": "https://www.pactoolsusa.com/collections/cat-retention-knobs",
    "/iU28Vb": "https://www.pactoolsusa.com/collections/bt-retention-knobs",
    // RETENTION KNOBS-PULL STUDS END //

    // CNC LIVE & DEAD CENTERS //
    "/sV18Xd": "https://www.pactoolsusa.com/collections/cnc-heavy-duty-model",
    "/xQ08Ag": "https://www.pactoolsusa.com/collections/interchangeable-cnc-heavy-duty-model",
    "/tT80Jb": "https://www.pactoolsusa.com/collections/cnc-small-casing-model",
    "/hQ30Ud": "https://www.pactoolsusa.com/collections/cnc-slimline-model",
    "/tN37Hs": "https://www.pactoolsusa.com/collections/dead-centers",
    // CNC LIVE & DEAD CENTERS END //

    // OTHER MACHINE TOOL ACCESSORIES //
    "/uW91On": "https://www.pactoolsusa.com/collections/er-nut",
    "/hV43Ma": "https://www.pactoolsusa.com/collections/er-wrench",
    "/cU15Ls": "https://www.pactoolsusa.com/collections/tool-locking-device",
    "/dD73Vm": "https://www.pactoolsusa.com/collections/spindle-wiper",
    // OTHER MACHINE TOOL ACCESSORIES END //


    // OTHER ACCESSORIES //
    "/wA08Dl": "https://www.pactoolsusa.com/collections/shrink-fit-holders",
    "/dW62Wq": "https://www.pactoolsusa.com/",
    "/kS37Zc": "https://www.pactoolsusa.com/",
    "/rG97El": "https://www.pactoolsusa.com/collections/5c-collets",
    "/zM60Ct": "https://www.pactoolsusa.com/collections/tool-holder-bushings",
    "/cF53Gp": "https://www.pactoolsusa.com/collections/retention-knobs",
    "/yE08Vk": "https://www.pactoolsusa.com/collections/cnc-live-dead-centers",
    // OTHER ACCESSORIES END //

  };
  var path = window.location.pathname;
  if (redirects[path]) {
    window.location.replace(redirects[path]);
  }
  if(window.location.pathname.includes("collections/all")){
    window.location.href = '/collections';
  }
})();
